"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("@jsluna/icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ChoiceImage = function ChoiceImage(_ref) {
  var _ref2;

  var image = _ref.image,
      showRemove = _ref.showRemove,
      onRemove = _ref.onRemove,
      maxWidth = _ref.maxWidth;
  return ((_ref2 = image && image.url) != null ? _ref2 : null) && !(Object.keys(image).length === 0 && image.constructor === Object) && /*#__PURE__*/_react.default.createElement("div", {
    role: "presentation",
    className: "image-option-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "image-container",
    style: {
      maxWidth: maxWidth != null ? maxWidth : 'initial'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: image.fileName,
    loading: "lazy",
    src: image.url,
    className: "image-style"
  }), showRemove && /*#__PURE__*/_react.default.createElement("button", {
    className: "cancel-button",
    onClick: onRemove
  }, /*#__PURE__*/_react.default.createElement(_icons.Cancel, {
    className: "image-remove"
  }))));
};

ChoiceImage.propTypes = {
  image: _propTypes.default.shape({
    fileName: _propTypes.default.string.isRequired,
    url: _propTypes.default.string.isRequired
  }),
  showRemove: _propTypes.default.bool,
  onRemove: _propTypes.default.func,
  width: _propTypes.default.string
};
ChoiceImage.defaultProps = {
  showRemove: false,
  onRemove: function onRemove() {},
  width: 'initial'
};
var _default = ChoiceImage;
exports.default = _default;